import { AriaRole } from 'react';

interface BaseSVGProps {
    fill?: string;
    stroke?: string;
}
interface DecorativeSVGProps extends BaseSVGProps {
    accessibilityType?: 'decorative';
}

interface InformativeSVGProps extends BaseSVGProps {
    accessibilityType?: 'informative';
    accessibilityLabel?: string;
    title?: string;
    desc?: string;
}

type SVGProps = DecorativeSVGProps | InformativeSVGProps;

function ZooplaLogo({ ...props }: SVGProps) {
    const ariaHidden: { informative: 'false'; decorative: 'true' } = {
        informative: 'false',
        decorative: 'true'
    };

    const title = 'title' in props ? props.title : undefined;
    const desc = 'desc' in props ? props.desc : undefined;
    const accessibilityLabel =
        'accessibilityLabel' in props ? props.accessibilityLabel : undefined;
    const role: AriaRole | undefined = props.accessibilityType
        ? {
              informative: 'img',
              decorative: 'presentation'
          }[props.accessibilityType]
        : undefined;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="110"
            height="20"
            fill="none"
            viewBox="0 0 920 167"
            aria-hidden={
                props.accessibilityType
                    ? ariaHidden[props.accessibilityType]
                    : undefined
            }
            aria-label={accessibilityLabel}
            role={role}
        >
            <g clipPath="url(#a)">
                <path
                    fill="#FF9524"
                    d="M129.865 132.349H35.608l-29.957 30.19h124.214v-30.19Z"
                />
                <path
                    fill="#FF2400"
                    d="M0 2.589v29.99h93.782c-.909 22.504-17.35 28.398-36.082 34.77C31.103 76.43-.435 88.02-.435 150.273v12.267h6.086l29.997-30.19c.908-23.857 17.823-30.189 36.951-36.8.949-.32 2.648-.917 3.597-1.275 20.471-7.21 42.405-17.127 50.23-50.622 1.818-8.006 2.964-18.042 2.964-28.995V2.589H0Z"
                />
                <path
                    fill="#FF9524"
                    d="M170.887 83.042c0-31.345 21.657-52.454 49.598-52.454s49.362 20.91 49.559 52.016l28.89-29.115C287.908 20.631 258.346-.558 220.683-.558c-48.018 0-83.626 34.532-83.626 83.6 0 38.633 22.053 67.668 54.855 78.302l26.755-26.963c-27.071-.837-47.819-20.831-47.819-51.3l.039-.039Z"
                />
                <path
                    fill="#FFCD00"
                    d="M499.343 2.39v32.778L531.868 2.39h-32.525ZM400.344 134.381c-27.941 0-49.836-20.233-49.836-51.34 0-31.105 21.855-52.453 49.836-52.453 27.98 0 49.361 21.11 49.361 52.454 0 .717 0 1.474-.04 2.19l29.759-29.95c-10.552-33.854-40.508-55.84-78.843-55.84-48.018 0-83.626 34.532-83.626 83.6 0 39.31 22.883 68.704 56.673 78.82l27.269-27.481h-.553ZM298.973 53.45l-28.889 29.114v.478c0 31.106-21.618 51.339-49.599 51.339-.592 0-1.185 0-1.778-.04l-26.755 26.963c8.892 2.868 18.535 4.421 28.771 4.421 48.017 0 82.953-33.615 82.953-82.683 0-10.634-1.62-20.552-4.703-29.593Z"
                />
                <path
                    fill="#00B62F"
                    d="M690.504 2.589h-33.593V60.02l33.593-33.854V2.59ZM479.424 55.242l-29.759 29.95c-.948 29.673-21.736 48.91-48.768 49.149l-27.269 27.481c8.378 2.509 17.428 3.864 26.992 3.864 48.018 0 82.954-33.616 82.954-82.684 0-9.917-1.462-19.237-4.11-27.8l-.04.04Z"
                />
                <path
                    fill="#008BFF"
                    d="M830.012-.558c-41.932 0-76.631 34.77-76.631 83.162 0 18.958 5.335 35.766 14.307 49.267l24.542-24.773c-3.241-7.01-5.059-15.214-5.059-24.534 0-31.106 20.314-51.578 48.927-51.578 9.603 0 18.14 2.23 25.372 6.253l17.271-17.404C866.726 6.61 849.93-.559 830.012-.559Z"
                />
                <path
                    fill="#00B62F"
                    d="M579.135-.558c-20.314 0-36.952 10.196-46.2 28.398V2.39h-1.027l-32.526 32.778V162.54h33.593v-57.233c9.485 18.879 26.597 28.398 46.199 28.398 1.66 0 3.281-.08 4.901-.2 27.743-2.31 50.744-24.016 55.171-55.6a79.47 79.47 0 0 0 .79-11.192c0-39.55-27.743-67.23-60.862-67.23l-.039-.04Zm-9.683 104.271c-20.946 0-36.517-14.776-36.517-37.04 0-22.265 16.243-37.04 36.517-37.04 21.42 0 37.189 14.537 37.189 37.04 0 22.502-15.769 37.04-37.189 37.04Z"
                />
                <path
                    fill="#008BFF"
                    d="M690.504 132.349V26.167l-33.593 33.854V162.54H751.8v-30.19h-61.296Z"
                />
                <path
                    fill="#9F46F6"
                    d="M896.13 2.589h-9.762V30.07c-2.213-3.704-4.743-7.05-7.469-10.116-.04-.04-.079-.12-.119-.16L861.51 37.2s.118.08.197.12c15.453 8.642 24.74 25.37 24.74 45.443 0 30.668-21.42 51.1-50.27 51.1-19.444 0-35.845-9.678-43.789-26.685 0-.04-.04-.12-.079-.159l-24.542 24.773.079.119c13.99 20.91 36.754 33.775 62.245 33.775 25.49 0 44.421-11.112 56.356-30.907v27.72h33.593V2.589h-23.91Z"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h920v167H0z" />
                </clipPath>
            </defs>
            {title && <title>{title}</title>}
            {desc && <desc>{desc}</desc>}
        </svg>
    );
}

export default ZooplaLogo;
